import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';

export interface FileDownloaderError {
  status: number;
  err: unknown;
}

const DOWNLOAD_TIMEOUT_MS = 60000;

@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  constructor(private http: HttpClient) {}

  download(url: string, filepath: string): Promise<File> {
    return firstValueFrom(
      this.http
        .get(url, {
          responseType: 'blob',
          observe: 'response',
        })
        .pipe(timeout(DOWNLOAD_TIMEOUT_MS)),
    )
      .then((response) => {
        const blob = response.body;

        if (!blob) {
          return Promise.reject<File>({
            status: response.status,
            err: 'Status Error',
          } as FileDownloaderError);
        }

        return new File([blob], filepath, {
          type: response.headers.get('content-type') || '',
        });
      })
      .catch((error) => {
        const status = error?.status ?? 0;

        if (status !== 0) {
          return Promise.reject({
            status,
            err: 'Status Error',
          } as FileDownloaderError);
        }

        return Promise.reject({
          status,
          err: error,
        } as FileDownloaderError);
      });
  }
}
